import React, { useCallback, useEffect, useState } from "react";

import { documentType as titles } from "consts/titulos-de-tablas";

import { Buttons, HeaderButton, TransitionModal } from "components";
import { Box } from "@mui/material";

import { DeleteModal, InsertModal, UpdateModal } from "./Actions";

import {
    userCredentials,
    rowSelected,
    routeInfo,
    modalData,
} from "recoilState/GlobalState";

import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

import { Routes } from "consts/Routes-App";
import { ACTIONS } from "consts/Actions";

import XGridDemo from "components/UI/Grid/XGrid";

import { useMIAService } from "hooks/useMIAService";
import { SBMTipoDeDocumentoGet } from "services/services-mia";

import tableStyles from "styles/pages/Tables.module.scss";
import Add from "@mui/icons-material/Add";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import Delete from "@mui/icons-material/Delete";

const prioridadMapper = {
    N: "Indistinto",
    I: "Primero internos",
    E: "Primero externos"
}

export default function DocumentType() {
    const credentials = useRecoilValue(userCredentials);
    const { action } = useRecoilValue(modalData);

    const setRoute = useSetRecoilState(routeInfo);
    const getSBMTipoDeDocumento = useMIAService(SBMTipoDeDocumentoGet);

    const [row, setRow] = useRecoilState(rowSelected);

    const [isLoading, setIsLoading] = useState(false);
    const [documentTypeLocalState, setDocumentTypeLocalState] = useState([]);

    const formatDocumentType = useCallback(async (
        tipoDeDocumentoId = null,
    ) => {
        setIsLoading((isLoading) => !isLoading);

        const result = await getSBMTipoDeDocumento({ tipoDeDocumentoId });

        const documentTypePartial = result.map((item) => {
            const {
                sbmTipoDeDocumentoDescripcion,
                sbmTipoDeDocumentoId,
                tipoDeDocumentoMerchantId,
                sbmTipoDeDocumentoNombre,
                sbmTipoDeDocumentoUFH,
                sbmTipoDeDocumentoUID,
                sbmTipoDeDocumentoVersion,
                sbmTipoDeDocumentoCod,
                sbmTipoDeDocumentoPrioridadIntExt,
                sbmTipoDeDocumentoPHFirmantes,
                sbmTipoDeDocumentoPHTickets,
                sbmTipoDeDocumentoMailer,
                sbmTipoDeDocumentoAgrupa,
                sbmTipoDeDocumentoAgrupaCantidad,
                sbmTipoDeDocumentoTieneDocumentos
            } = item;

            return {
                id: sbmTipoDeDocumentoId,
                tipoDeDocumentoDescripcion: sbmTipoDeDocumentoDescripcion,
                tipoDeDocumentoMerchantId: tipoDeDocumentoMerchantId,
                tipoDeDocumentoNombre: sbmTipoDeDocumentoNombre,
                tipoDeDocumentoUFH: sbmTipoDeDocumentoUFH,
                tipoDeDocumentoUID: sbmTipoDeDocumentoUID,
                tipoDeDocumentoVersion: sbmTipoDeDocumentoVersion,
                tieneDocumento: sbmTipoDeDocumentoTieneDocumentos,
                [titles[0]]: sbmTipoDeDocumentoNombre,
                [titles[1]]: sbmTipoDeDocumentoCod,
                [titles[2]]: sbmTipoDeDocumentoDescripcion,
                [titles[3]]: prioridadMapper[sbmTipoDeDocumentoPrioridadIntExt],
                [titles[4]]: sbmTipoDeDocumentoPHFirmantes === "Y" ? "Si" : "No",
                [titles[5]]: sbmTipoDeDocumentoPHTickets === "Y" ? "Si" : "No",
                [titles[6]]: sbmTipoDeDocumentoMailer === "Y" ? "Si" : "No",
                [titles[7]]: sbmTipoDeDocumentoAgrupa === "Y" ? "Si" : "No",
                [titles[8]]: sbmTipoDeDocumentoAgrupaCantidad
            };
        });

        setDocumentTypeLocalState(documentTypePartial);

        setIsLoading((isLoading) => !isLoading);
    }, [getSBMTipoDeDocumento]);

    const handleUpdateTable = useCallback(() => {
        formatDocumentType();
        setRow({ status: false, row: {} });
    }, [formatDocumentType, setRow]);

    useEffect(() => {
        if (credentials) handleUpdateTable();
    }, [credentials, handleUpdateTable]);

    useEffect(() => {
        setRoute(Routes.documentTypeTable);
    }, [setRoute]);

    return (
        <section className={tableStyles.section}>

            <TransitionModal
                confirmationModal={
                    (action === ACTIONS.INSERT || action === ACTIONS.UPDATE) ??
                    true
                }
                customOnClose={handleUpdateTable}
            >
                {action === ACTIONS.UPDATE && (
                    <UpdateModal handleUpdateTable={handleUpdateTable} />
                )}
                {action === ACTIONS.DELETE && (
                    <DeleteModal handleUpdateTable={handleUpdateTable} />
                )}
                {action === ACTIONS.INSERT && (
                    <InsertModal handleUpdateTable={handleUpdateTable} />
                )}
            </TransitionModal>
            <Box display={"flex"} justifyContent={"flex-end"}>


                <Buttons filtersApplied={true}>
                    <>
                        <HeaderButton
                            text={"Crear"}
                            disabled={row.status}
                            data={{
                                action: ACTIONS.INSERT,
                                title: "Tipo de Documento - Crear",
                                button: "Enviar",
                            }}
                        >
                            <Add />
                        </HeaderButton>

                        <HeaderButton
                            text={"Eliminar"}
                            disabled={!row.status}
                            data={{
                                action: ACTIONS.DELETE,
                                title: "Tipo de Documento - Eliminar",
                                button: "Confirmar",
                            }}
                        >
                            <Delete />
                        </HeaderButton>

                        <HeaderButton
                            text={"Editar"}
                            disabled={!row.status}
                            data={{
                                action: ACTIONS.UPDATE,
                                title: "Tipo de Documento - Editar",
                                button: "Confirmar",
                            }}
                        >
                            <EditOutlined />
                        </HeaderButton>

                        <HeaderButton
                            text={"Actualizar página"}
                            disabled={row.status}
                            onClick={handleUpdateTable}
                        >
                            <Cached />
                        </HeaderButton>
                    </>
                </Buttons>
            </Box>
            <XGridDemo
                rows={documentTypeLocalState}
                titles={titles}
                loading={isLoading}
            />
        </section>
    );
}
